var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plant"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"Router"})],1),_vm._v(" "),_c('img',{staticClass:"plant-icon",attrs:{"src":require("../../../assets/content-box.png")}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-875da070","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/maintain/plant/Plant.vue
// module id = null
// module chunks = 